import { useEffect, useMemo, useState } from "react";
import { Button, Col, Container, Dropdown, DropdownButton, Form, Row } from "react-bootstrap";
import styles from "./addStaff.module.scss";
// img
import { useNavigate, useParams } from "react-router-dom";
import { FieldArray, Formik } from "formik";
import LoadingIndicator from "components/shared/LoadingIndicator";
import ErrorComponent from "components/shared/ErrorComponent";
import LoadingOverlay from "components/shared/LoadingOverlay";
import { dateFormat, dobFormat, errorMessageToast, getAge, getPdfBlob, successMessageToast, userFullName } from "helpers/common";
import LoadingButton from "components/shared/LoadingButton";
import moment from "moment";
// import ReportError from "components/shared/ReportsV2/ReportError";
import AppDatePicker from "components/shared/FormComponents/AppDatePicker";
import { useSelector } from "react-redux";
import CustomEditor from "components/TipTapEditor/CustomeEditor";
// import { schoolDischargeScreeningValidationSchema } from "./validation";
import threDots_img from "Assets/images/three-dots.png"
import date_img from "Assets/images/date.png"
import { AppSelect2Field } from "components/shared/FormComponents/AppSelect2Field";
import ViewPdfModal from "components/Modals/ViewPdfModal";
// import IntakePdfDocV2 from "./IntakePdfDoc";
import { useCreateIntakeReportMutation, useGetHomeEducationClientDetailsQuery, useGetHomeEducationIntakeDetailsQuery } from "store/services/clients/homeEducation.client";
import { useUploadFileMutation } from "store/services/utility";
import { ReportsNoRecordMessage } from "components/Common/Common";
import { CHATTER_PEER_DETAILS, VIEW_HOME_EDUCATION } from "config/paths";
import intakeFormSchema from "./intake.schema";
import PdfPublishModal from "components/Modals/PdfPublishModal";
import AppInputField from "components/shared/FormComponents/AppInputField";
import { useChatterPeerDetailsQuery, useCreateReferenceLetterV2Mutation } from "store/services/chatter/peer";
import peerReferenceSchema from "./referencepeer.schema";
import PdfPeerModal from "components/Modals/PdfPublishPeer";
import IntakePdfDocV2 from "pages/SideTabPages/Clients/HomeEducation/IntakeReportV2/IntakePdfDoc";
import PeerPdfViewV2 from "pages/SideTabPages/Clients/Chatter/PeerPdfV2/PeerPdfDoc";



const VolunteerReferenceLetter = () => {
    const navigate = useNavigate();
    const [previewMode, setPreviewMode] = useState(false)
    const [submitting, setSubmitting] = useState(false)
    const [pdfModal, setPdfModal] = useState(false)
    const [document, setDocument] = useState(null)
    const { id: clientId } = useParams();
    const { chatterId: peerId } = useParams();

    const clientType = "home_education"
    const [initialValues, setInitialValues] = useState({})
    const [publishPdfModal, setPublishPdfModal] = useState(false)


    const [uploadFile, { isLoading: isUploading }] = useUploadFileMutation()
    const data = ""
    const isLoading = ""
    const refetch = ''
    const isError = ''
    const isFetching = ''

    const { data: peerDetails, isLoading: loadingPeerDetails } = useChatterPeerDetailsQuery(peerId);
    const [createReferenceLetterV2, { isLoading: isReferenceSaving }] = useCreateReferenceLetterV2Mutation()

    const handleSubmitStep = async (values) => {

        try {
            let body = {}
            if (values?.save_for_later) {
                body = {
                    ...values,
                    last_name: peerDetails?.firstname,
                    first_name: peerDetails?.lastname,
                    hours_volunteered: values?.hours_volunteered?.toString(),
                    weeks_volunteered: values?.weeks_volunteered?.toString(),
                    save_for_later: "yes",
                }
            }

            else {

                const pdfData = {
                    lastname: peerDetails?.lastname,
                    firstname: peerDetails?.firstname,
                    city_town: peerDetails?.client_detail?.city_town,
                    start_date: values?.start_date,
                    weeks_volunteered: values?.weeks_volunteered,
                    hours_volunteered: values?.hours_volunteered,
                    ...values
                }
                const doc = (
                    <PeerPdfViewV2 data={pdfData} />
                )

                const filename = `refernceletter ${moment(new Date()).format("YYYY-MM-DD")}.pdf`
                let pdfFile = await getPdfBlob(doc, false, filename);

                let uploadedFileName = await uploadFile({ file: pdfFile, acl: "private", fileOriginalFormat: true }).unwrap();

                if (!uploadedFileName) {
                    throw new Error("File not uploaded");
                };

                body = {
                    ...values,
                    last_name: peerDetails?.firstname,
                    first_name: peerDetails?.lastname,
                    hours_volunteered: values?.hours_volunteered?.toString(),
                    weeks_volunteered: values?.weeks_volunteered?.toString(),
                    save_for_later: "no",
                    attachment_key: uploadedFileName,
                    attachment_name: uploadedFileName,
                }

            }

            const response = await createReferenceLetterV2({ data: body, peerId: peerId }).unwrap()
            if (response.status === "success") {
                successMessageToast(response?.message)
                navigate(CHATTER_PEER_DETAILS.replace(":id", peerId))
            }

        } catch (error) {
            setSubmitting(false);
            console.log('error', error)
        }

    };

    const handleViewPdf = (values) => {
        const pdfData = {
            lastname: peerDetails?.lastname,
            firstname: peerDetails?.firstname,
            city_town: peerDetails?.client_detail?.city_town,
            start_date: values?.start_date,
            weeks_volunteered: values?.weeks_volunteered,
            hours_volunteered: values?.hours_volunteered,
            about_chatter: {
                ...values.about_chatter,
                attachments: values?.about_chatter?.attachments || []
            },
            about_chatter: {
                ...values.about_chatter,
                attachments: values?.about_chatter?.attachments || []
            },
            ...values
        }
        const doc = (
            <PeerPdfViewV2 data={pdfData} />
        )
        setDocument(doc)
        setPdfModal(true)
    };

    useEffect(() => {
        setInitialValues((prev) => ({
            ...prev,
            weeks_volunteered: peerDetails?.saved_reference_letter?.weeks_volunteered ?? "",
            hours_volunteered: peerDetails?.saved_reference_letter?.hours_volunteered ?? "",
            start_date: moment(peerDetails?.saved_reference_letter?.start_date || new Date()).format("YYYY-MM-DD"),
            about: {
                text: peerDetails?.saved_reference_letter?.about?.text ?? "",
                attachments: peerDetails?.saved_reference_letter?.about?.attachments ?? []
            },
            about_chatter: {
                text: peerDetails?.saved_reference_letter?.about_chatter?.text ?? "",
                attachments: peerDetails?.saved_reference_letter?.about_chatter?.attachments ?? []
            },
            emailFormData: {
                recipientList: [
                    {
                        firstname: peerDetails?.firstname ?? "",
                        lastname: peerDetails?.lastname ?? "",
                        email: peerDetails?.email ?? ""
                    }
                ]
            },

        }))
        // }

    }, [peerDetails])

    const guardianList = [{
        client_guardian: {
            firstname: peerDetails?.firstname,
            lastname: peerDetails?.lastname,
            email: peerDetails?.email,
            client_role: {
                title: peerDetails?.client_role.title,
                slug: peerDetails?.client_role.slug,
            }
        }

    }]

    return (
        <>
            <section className="ReportSec schooldeschargeInput proxima container-discharge-screen py-3 position-relative">
                <Container fluid>
                    <div style={{ maxWidth: "80%", margin: "0 auto" }}>
                        <Formik
                            initialValues={initialValues}
                            onSubmit={handleSubmitStep}
                            validationSchema={peerReferenceSchema}
                            enableReinitialize
                        >
                            {({ handleSubmit, values, errors, touched, setFieldValue, submitForm, validateForm,
                                setTouched }) => (
                                <Form onSubmit={handleSubmit}>
                                    <ViewPdfModal publishPdfCheckbox={false} isPopup={true} show={pdfModal} clientType={clientType} setShow={setPdfModal} doc={document} handleSubmit={submitForm} guardianList={guardianList} type="peer" />
                                    <PdfPeerModal publishPdfCheckbox={false} show={publishPdfModal} setShow={setPublishPdfModal} clientType={"peer"} doc={document} handleSubmit={submitForm} guardianList={guardianList} />
                                    {(loadingPeerDetails) ? (
                                        <LoadingIndicator />
                                    ) : isError ? (
                                        <ErrorComponent />
                                    ) : (
                                        <Row>
                                            <Col lg="12" className="my-2">
                                                {console.log('formik values', values)}
                                                <div className="bg-white">
                                                    <>
                                                        {(submitting || isReferenceSaving || isUploading) && <LoadingOverlay />}
                                                        <div className="formBody reports-v2">
                                                            {/* <h5 className="section-title mb-0 border-0" style={{ fontSize: "11px", textTransform: "uppercase", letterSpacing: "1px" }}>Speech Language Pathology</h5> */}
                                                            <p style={{ fontSize: "20px", marginTop: "5px", color: "#000" }}>Volunteer Reference Letter</p>
                                                            <div
                                                                className="mt-4 client-view"
                                                            // style={{ borderBottom: "2px dashed #6c6c6c" }}
                                                            >


                                                                <h5 className="section-title">VOLUNTEER INFORMATION</h5>
                                                                <div className="mb-3 d-flex align-items-center" style={{ gap: "200px" }}>
                                                                    <div style={{ width: "50%" }}>
                                                                        <div style={{ width: "100%" }}>
                                                                            <label className="discharge-screen-label">Last Name</label>
                                                                            <input className="readonly-box" readOnly value={peerDetails?.lastname} />
                                                                        </div>
                                                                    </div>
                                                                    <div className="d-flex gap-3" style={{ width: "50%" }}>
                                                                        <div style={{ width: "50%" }}>
                                                                            <label className="discharge-screen-label">Start Date</label>
                                                                            <div style={{ width: "100%" }} className="readonly-box d-flex align-items-center">
                                                                                {/* <input name="" style={{ outline: "none" }} className="border-0 w-100" value={dateFormat(intakeData?.date_of_intake, dobFormat)} type="date" /> */}
                                                                                <AppInputField
                                                                                    name="start_date"
                                                                                    type="date"
                                                                                    style={{ outline: "none", border: "none", width: "100%" }}
                                                                                />
                                                                                {/* <img width={14} height={16} src={date_img} alt="date_img" /> */}
                                                                            </div>
                                                                            {/* <div className="readonly-box d-flex align-items-center">
                                                                                    <input style={{ outline: "none" }} className="border-0 w-100" readOnly value={dateFormat(data?.client_detail?.dob, dobFormat)} />
                                                                                    <img width={14} height={16} src={date_img} alt="date_img" />
                                                                                </div> */}
                                                                        </div>
                                                                        <div style={{ width: "50%" }}>
                                                                            <div style={{ width: "100%" }}>
                                                                                <label className="discharge-screen-label">Weeks Volunteered</label>
                                                                                {/* <input className="readonly-box normal-grade" readOnly value={data?.client_detail?.grade} /> */}
                                                                                <AppInputField
                                                                                    name="weeks_volunteered"
                                                                                    type="number"
                                                                                    className="readonly-box normal-grade"
                                                                                // style={{ outline: "none", border: "none" }}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    {/* <div style={{ width: "30%" }}>
                                                                            <label className="discharge-screen-label">City/Town</label>
                                                                            <input className="readonly-box" readOnly value={data?.client_detail?.city_town} />
                                                                        </div>
                                                                        <div style={{ width: "20%" }}>
                                                                            <label className="discharge-screen-label">Date of Report</label>
                                                                            <div className="readonly-box d-flex align-items-center">
                                                                                <input style={{ outline: "none" }} className="border-0 w-100" readOnly value={moment().format("YYYY-MM-DD")} />
                                                                                <img width={14} height={16} src={date_img} alt="date_img" />
                                                                            </div>
                                                                        </div> */}
                                                                </div>

                                                                <div className="mb-3 d-flex align-items-start" style={{ gap: "200px" }}>
                                                                    <div style={{ width: "50%" }}>
                                                                        <div style={{ width: "100%" }} className="mb-3">
                                                                            <label className="discharge-screen-label">First Name</label>
                                                                            <input className="readonly-box" readOnly value={peerDetails?.firstname} />
                                                                        </div>
                                                                    </div>
                                                                    <div className="d-flex gap-3" style={{ width: "50%" }}>
                                                                        <div style={{ width: "100%" }}>
                                                                            {/* <label className="discharge-screen-label">Grade</label>
                                                                                <input className="readonly-box normal-grade" readOnly value={data?.client_detail?.grade} /> */}
                                                                        </div>
                                                                        <div style={{ width: "100%" }}>
                                                                            <div style={{ width: "100%" }}>
                                                                                <label className="discharge-screen-label">Hours Volunteered</label>
                                                                                <AppInputField
                                                                                    name="hours_volunteered"
                                                                                    type="number"
                                                                                    className="readonly-box normal-grade"
                                                                                // style={{ outline: "none", border: "none" }}
                                                                                />                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                {/* {data?.client_detail?.client_guardian_mapping?.length > 0 ?
                                                                        [...data?.client_detail?.client_guardian_mapping] // clone the array
                                                                            .map((guardian, index) => {
                                                                                const slug = "parent"
                                                                                if (slug !== (clientType === "home_education" ? "parent" : "teacher")) {
                                                                                    return null;
                                                                                }
                                                                                if ([0, 1].includes(index)) {
                                                                                    return (
                                                                                        <div className="mt-5">
                                                                                            <GuardianDetailList
                                                                                                previewMode={previewMode}
                                                                                                key={index}
                                                                                                index={index}
                                                                                                guardian={guardian}
                                                                                                slug={slug}
                                                                                                values={values}
                                                                                            />
                                                                                        </div>
                                                                                    );
                                                                                }
                                                                                else {
                                                                                    return
                                                                                }
                                                                            }) : <ReportsNoRecordMessage msg="No teacher is currently assigned to this client." />
                                                                        // <ReportsNoRecordMessage msg="No teacher is currently assigned to this client." />
                                                                    } */}


                                                                <Row className="justify-content-between mt-3">
                                                                    <Col lg="12">
                                                                        <h5 className="section-title mb-0">ABOUT THE VOLUNTEER</h5>
                                                                    </Col>
                                                                </Row>
                                                                <div className="py-2 reports-v2 position-relative">
                                                                    <>
                                                                        <div>
                                                                            {/* <h6 class="m-0 proxima themeBlue fw-bold text-uppercase mt-4" style={{ fontSize: "12px", borderBottom: "0.75px solid #000" }}>{''}</h6> */}
                                                                            <Row className={`reports-v2-question`}>

                                                                                {/* <Col lg="4 py-3">
                                                                                                <p style={{ fontStyle: "italic", color: "#071E3E" }}>{item?.placeholder}</p>
                                                                                            </Col> */}
                                                                                <Col lg="8 py-3">
                                                                                    <div className="ck-editor-wrapper">
                                                                                        <CustomEditor limit={1500} previewMode={previewMode} attachmentName={'about.attachments'} name={'about.text'} />
                                                                                    </div>
                                                                                </Col>

                                                                            </Row>
                                                                        </div>
                                                                    </>
                                                                </div>



                                                                <Row className="justify-content-between mt-3">
                                                                    <Col lg="12">
                                                                        <h5 className="section-title mb-0">ABOUT THE CHATTER PROGRAM</h5>
                                                                    </Col>
                                                                </Row>
                                                                <div className="py-2 reports-v2 position-relative">
                                                                    <>
                                                                        <div>
                                                                            {/* <h6 class="m-0 proxima themeBlue fw-bold text-uppercase mt-4" style={{ fontSize: "12px", borderBottom: "0.75px solid #000" }}>{''}</h6> */}
                                                                            <Row className={`reports-v2-question`}>

                                                                                {/* <Col lg="4 py-3">
                                                                                                <p style={{ fontStyle: "italic", color: "#071E3E" }}>{item?.placeholder}</p>
                                                                                            </Col> */}
                                                                                <Col lg="8 py-3">
                                                                                    <div className="ck-editor-wrapper">
                                                                                        <CustomEditor limit={1500} previewMode={previewMode} attachmentName={'about_chatter.attachments'} name={'about_chatter.text'} />
                                                                                    </div>
                                                                                </Col>

                                                                            </Row>
                                                                        </div>
                                                                    </>
                                                                </div>
                                                            </div>
                                                            <div className="">
                                                            </div>
                                                        </div>
                                                    </>
                                                </div>
                                            </Col>

                                            <Col lg="12" className="my-4">
                                                {/* <ReportError /> */}
                                                <div className='d-flex gap-3 align-items-center justify-content-end'>
                                                    <button
                                                        type="button"
                                                        className="d-flex align-items-center gap-2 justify-content-center preview-discharge-screen"
                                                        // isLoading={submittingStep}
                                                        disabled={submitting || isReferenceSaving}
                                                        onClick={() => handleViewPdf(values)}
                                                    >
                                                        <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M0 0.777778C0 0.571498 0.0842854 0.373667 0.234315 0.227806C0.384344 0.0819442 0.587827 0 0.8 0H15.2C15.4122 0 15.6157 0.0819442 15.7657 0.227806C15.9157 0.373667 16 0.571498 16 0.777778V13.2222C16 13.4285 15.9157 13.6263 15.7657 13.7722C15.6157 13.9181 15.4122 14 15.2 14H0.8C0.587827 14 0.384344 13.9181 0.234315 13.7722C0.0842854 13.6263 0 13.4285 0 13.2222V0.777778ZM1.6 1.55556V12.4444H14.4V1.55556H1.6ZM3.2 3.11111H4.8V4.66667H3.2V3.11111ZM4.8 6.22222H3.2V7.77778H4.8V6.22222ZM3.2 9.33333H4.8V10.8889H3.2V9.33333ZM12.8 3.11111H6.4V4.66667H12.8V3.11111ZM6.4 9.33333H12.8V10.8889H6.4V9.33333ZM12.8 6.22222H6.4V7.77778H12.8V6.22222Z" fill="white" />
                                                        </svg>

                                                        Preview
                                                    </button>
                                                    <>
                                                        <LoadingButton
                                                            onClick={() => setFieldValue('save_for_later', true)}
                                                            type="submit"
                                                            className="d-flex align-items-center justify-content-center save-discharge-screen"
                                                            disabled={previewMode || submitting || isReferenceSaving}
                                                        // isLoading={(values?.save_for_later && submitting)}
                                                        >
                                                            Save
                                                        </LoadingButton>

                                                        <LoadingButton
                                                            // onClick={() => { setFieldValue('save_for_later', false) }}
                                                            onClick={async () => {
                                                                setFieldValue('save_for_later', false);
                                                                const errors = await validateForm();
                                                                setTouched({
                                                                    start_date: true,
                                                                    weeks_volunteered: true,
                                                                    hours_volunteered: true,
                                                                    about: {
                                                                        text: true
                                                                    },
                                                                    about_chatter: {
                                                                        text: true
                                                                    }
                                                                });

                                                                setPublishPdfModal(true);
                                                            }
                                                            }
                                                            type="button"
                                                            className="d-flex align-items-center gap-2 justify-content-center discharge-screen"
                                                            disabled={previewMode || submitting || isReferenceSaving}
                                                        // isLoading={(!values?.save_for_later && submitting)}
                                                        >
                                                            SUBMIT & Export
                                                            <svg width="14" height="9" viewBox="0 0 14 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M9.68197 3.24568L8.85675 0.5H10.2193L14 4.29259V4.70741L10.2193 8.5H8.85675L9.68197 5.75432H0V3.24568H9.68197Z" fill="white" />
                                                            </svg>
                                                        </LoadingButton>

                                                    </>
                                                </div>
                                            </Col>

                                        </Row>
                                    )}
                                </Form>
                            )}
                        </Formik>
                    </div>
                </Container>
            </section>
        </>
    );
};

export default VolunteerReferenceLetter;